import {useGetData} from '../../src/apiservice/apiCall'


export function useGetSlider(){
	return useGetData('/api/WebApi/GetSlider')
}
